import { Injectable } from "@angular/core";
import { BaseProvider } from "../../../../shared/providers/base-provider";
import { TemperatureNotifier } from "./temperature-notifier";
import { TemperatureState } from "./temperature-state";

@Injectable()
export class TemperatureProvider extends BaseProvider<
  TemperatureNotifier,
  TemperatureState
> {
  constructor() {
    super(TemperatureNotifier);
  }
}
